import React from 'react'
import { General } from "../tools/styles"
import FloatCard from "./ui/FloatCard";
import { theme } from "../theme";

const Method = ({
    currentValue = "",
  methodArray = [],
  handleChange = function () {
    console.log("no function defined");
  },
}) => {
  return (
    <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              
              <General.Select
                name="method"
                onChange={handleChange}
                value={currentValue}
              >
                <option value="">-- Please choose an option</option>
                {methodArray.map((metric, i) => (
                  <option key={i} value={metric}>
                    {metric}
                  </option>
                ))}
              </General.Select>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Method</h2>
        </General.Block>
      </General.BlockContainer>
  )
}

export default Method